import type { UserProfile, UserWithProfile } from "@/types/user-profile";

export enum UserKind {
  Internal = "internal",
  Agency = "agency",
}

export function userKindOf(user: Pick<UserWithProfile, "agencia_id">): UserKind {
  return user.agencia_id ? UserKind.Agency : UserKind.Internal;
}

export function profileKindOf(profile: Pick<UserProfile, "slug">): UserKind {
  return profile.slug?.includes("agencia") ? UserKind.Agency : UserKind.Internal;
}
